import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { NotificationService } from '../../services/notification.service';
import { Observable } from 'rxjs';
import { withLatestFrom, switchMap } from 'rxjs/operators';

import {
  ClearCurrentCp,
  ClearCurrentMcp,
  ClearScopeOfWork,
  CurrentTask,
  TaskActionTypes,
  TasksLoad,
  TasksLoadSuccess,
} from '@completion/actions';
import { State } from '@completion/reducers';
import { ProjectService } from '../../services';
import { getCurrentProject } from '../selectors';
import { ResourceEffect } from './resource.effect';
import { Project } from '@completion/models';
import { trackResource } from './resource-fetch.util';

@Injectable()
export class TaskEffect extends ResourceEffect {
  constructor(
    readonly actions$: Actions,
    readonly service: ProjectService,
    readonly store: Store<State>,
    readonly toastr: NotificationService,
  ) {
    super(actions$, service, store, toastr);
  }

  loadTasks$ = createEffect(() =>
    this.actions$.pipe(
      ofType<TasksLoad>(TaskActionTypes.TasksLoad),
      withLatestFrom(this.store.select(getCurrentProject) as Observable<Project>),
      trackResource({
        actions$: this.actions$,
        store: this.store,
        toastr: this.toastr,
        service: this.service,
        method: 'getTasks',
        serviceArgs: ([_, currentProject]) => [currentProject.id],
        onSuccess: (tasks) => new TasksLoadSuccess(tasks as any),
      }),
    ),
  );

  changeTask$ = createEffect(() =>
    this.actions$.pipe(
      ofType<CurrentTask>(TaskActionTypes.CurrentTask),
      switchMap(() => [new ClearCurrentCp(), new ClearScopeOfWork(), new ClearCurrentMcp()]),
    ),
  );
}
